// Datos centrales del sitio Lu Design (contenido de ejemplo, editable)

export const BRAND = {
  name: "Lu Design",
  slogan: "Diseño que conecta e inspira",
  logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_e1b0c2f7-22b3-4684-ac7c-e205b18a6ff2/artifacts/5fu6vvac_Lu%20Design%20Logo.png",
};

// WhatsApp: +52 81 2595 2909
export const CONTACT = {
  whatsappNumber: "528125952909",
  whatsappDisplay: "+52 81 2595 2909",
  email: "hola@ludesign.com.mx",
  location: "Monterrey, Nuevo León · México",
  socials: [
    { name: "Instagram", icon: "fa-brands fa-instagram", url: "https://instagram.com" },
    { name: "Pinterest", icon: "fa-brands fa-pinterest", url: "https://pinterest.com" },
    { name: "Behance", icon: "fa-brands fa-behance", url: "https://behance.net" },
  ],
};

export const waLink = (message) =>
  `https://wa.me/${CONTACT.whatsappNumber}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

export const NAV_LINKS = [
  { label: "Inicio", to: "/" },
  { label: "Servicios", to: "/servicios" },
  { label: "Portafolio", to: "/portafolio" },
  { label: "Sobre mí", to: "/sobre-mi" },
  { label: "Contacto", to: "/contacto" },
];

export const SERVICES = [
  {
    id: "diseno-web",
    number: "01",
    icon: "Monitor",
    title: "Diseño Web",
    short: "Sitios a la medida que combinan estética y estrategia para convertir visitas en conexiones reales.",
    long: "Creamos experiencias digitales que reflejan la esencia de tu marca. Diseño responsivo, tiempos de carga cuidados y una narrativa visual que guía a tus visitantes hacia la acción, siempre con un acabado impecable en cada pantalla.",
    image:
      "https://images.unsplash.com/photo-1654372066425-d0a1eccb2549?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwY3JlYXRpdmUlMjB3b3Jrc3BhY2V8ZW58MHx8fHwxNzg1Nzg0ODA4fDA&ixlib=rb-4.1.0&w=1000&q=70&auto=format&fit=crop",
  },
  {
    id: "invitaciones",
    number: "02",
    icon: "Mail",
    title: "Invitaciones Digitales",
    short: "Invitaciones animadas y elegantes que hacen que cada evento comience a sentirse especial desde el primer clic.",
    long: "Bodas, XV años, bautizos o eventos corporativos: diseñamos invitaciones digitales interactivas con animaciones suaves, confirmación de asistencia y detalles personalizados que emocionan a tus invitados antes del gran día.",
    image:
      "https://images.unsplash.com/photo-1632610992723-82d7c212f6d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwd2VkZGluZyUyMGludml0YXRpb24lMjBmbGF0bGF5fGVufDB8fHx8MTc4NTc4NDgwOHww&ixlib=rb-4.1.0&w=1000&q=70&auto=format&fit=crop",
  },
  {
    id: "diseno-grafico",
    number: "03",
    icon: "PenTool",
    title: "Diseño Gráfico",
    short: "Identidades visuales, papelería y piezas para redes que dan coherencia y alma a tu marca.",
    long: "Desde el logotipo hasta cada publicación: construimos sistemas visuales sólidos y memorables. Paletas, tipografías y composiciones pensadas para que tu marca se reconozca y se sienta en cualquier formato.",
    image:
      "https://images.unsplash.com/photo-1617050318658-a9a3175e34cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwZWRpdG9yaWFsJTIwZ3JhcGhpYyUyMGRlc2lnbnxlbnwwfHx8fDE3ODU3ODQ4MDh8MA&ixlib=rb-4.1.0&w=1000&q=70&auto=format&fit=crop",
  },
  {
    id: "fotografia",
    number: "04",
    icon: "Camera",
    title: "Fotografía Profesional",
    short: "Imágenes que capturan la emoción y el detalle, listas para contar la historia de tu marca o evento.",
    long: "Producto, retrato, eventos y contenido para redes. Dirección de arte, iluminación cuidada y edición delicada para que cada imagen transmita exactamente lo que quieres comunicar, con una estética limpia y atemporal.",
    image:
      "https://images.unsplash.com/photo-1471341971476-ae15ff5dd4ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBjYW1lcmElMjBzdHVkaW8lMjBwaG90b2dyYXBoeXxlbnwwfHx8fDE3ODU3ODQ4MDh8MA&ixlib=rb-4.1.0&w=1000&q=70&auto=format&fit=crop",
  },
];

// Categorías del portafolio (la primera muestra todo)
export const PORTFOLIO_CATEGORIES = [
  "Todos",
  "Diseño Web",
  "Invitaciones Digitales",
  "Diseño Gráfico",
  "Fotografía",
];

// Genera una vista previa (screenshot) de un sitio web mediante WordPress mShots
export const siteShot = (url, w = 1200, h = 900) =>
  `https://s.wordpress.com/mshots/v1/${encodeURIComponent(url)}?w=${w}&h=${h}`;

export const PORTFOLIO = [
  {
    id: "alma-mia",
    type: "web",
    title: "Alma Mía · Arte Floral",
    category: "Diseño Web",
    year: "2024",
    description:
      "Sitio web para un estudio de arte floral. Una experiencia delicada y orgánica que refleja la sensibilidad de cada arreglo.",
    url: "https://www.almamiaartefloral.com/",
  },
  {
    id: "producciones-palacios",
    type: "web",
    title: "Producciones Palacios",
    category: "Diseño Web",
    year: "2024",
    description:
      "Sitio web para una productora de eventos. Diseño sólido y elegante que transmite experiencia y confianza.",
    url: "https://www.produccionespalacios.com.mx/",
  },
  {
    id: "vida-frutal",
    type: "web",
    title: "Vida Frutal",
    category: "Diseño Web",
    year: "2025",
    description:
      "Sitio web para una marca de aguas frescas naturales en Monterrey. Fresco, apetitoso y lleno de color, pensado para antojar y vender.",
    url: "https://gray-turtle-454927.hostingersite.com/",
  },
  {
    id: "invitacion-maria-adan",
    type: "web",
    title: "María & Adán",
    category: "Invitaciones Digitales",
    year: "2026",
    description:
      "Invitación digital de boda con animaciones suaves y confirmación de asistencia. Elegante y romántica, hecha para emocionar a los invitados.",
    url: "https://purple-baboon-557157.hostingersite.com/",
  },
  {
    id: "invitacion-boda",
    type: "image",
    title: "Invitación de boda",
    category: "Invitaciones Digitales",
    year: "Próximamente",
    description: "Muy pronto compartiremos este proyecto con todo su detalle.",
  },
  {
    id: "invitacion-xv",
    type: "image",
    title: "Invitación de XV años",
    category: "Invitaciones Digitales",
    year: "Próximamente",
    description: "Muy pronto compartiremos este proyecto con todo su detalle.",
  },
];

export const ABOUT_PORTRAIT = "/about/lu-portrait-v2.jpg";
